// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sp-nav-menu[data-v-33e8f1d7]{background:#fff;left:0;right:0;top:0;max-height:100vh;overflow:auto}.menu-content-list[data-v-33e8f1d7]{font-weight:600;color:#333}.menu-content-list[data-v-33e8f1d7]:hover{background:#dff5f7}.hamburger-menu[data-v-33e8f1d7]{z-index:20;right:0;top:0;cursor:pointer}.menu-content-dorp-down[data-v-33e8f1d7]{text-align:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
